import { setup, assign } from 'xstate';

interface SidebarContext {
  sidebarOpened: boolean;
  sidebarMinimized: boolean;
  sidebarHovered: boolean;
  headerOpened: boolean;
}

type SidebarEvent =
  | { type: 'OPEN_SIDEBAR' }
  | { type: 'MINIMIZE_SIDEBAR' }
  | { type: 'HOVER_SIDEBAR' }
  | { type: 'OPEN_HEADER' };

function isMinimizeSidebarEvent(
  event: SidebarEvent
): event is { type: 'MINIMIZE_SIDEBAR'; value?: boolean } {
  return event.type === 'MINIMIZE_SIDEBAR';
}

const sidebarMachine = setup({
  types: {
    context: {} as SidebarContext,
    events: {} as SidebarEvent,
  },
  actions: {
    toggleSidebarOpened: assign({
      sidebarOpened: ({ context }) => !context.sidebarOpened,
    }),
    toggleSidebarMinimized: assign({
      sidebarMinimized: ({ context, event }) => {
        if (isMinimizeSidebarEvent(event)) {
          return typeof event.value === 'boolean' ? event.value : !context.sidebarMinimized;
        }
        return context.sidebarMinimized;
      },
    }),
    toggleSidebarHovered: assign({
      sidebarHovered: ({ context }) => !context.sidebarHovered,
    }),
    toggleHeaderOpened: assign({
      headerOpened: ({ context }) => !context.headerOpened,
    }),
  },
}).createMachine({
  id: 'SidebarMachine',
  initial: 'active',
  context: {
    sidebarOpened: false,
    sidebarMinimized: false,
    sidebarHovered: false,
    headerOpened: false,
  },
  states: {
    active: {
      on: {
        OPEN_SIDEBAR: { actions: 'toggleSidebarOpened' },
        MINIMIZE_SIDEBAR: { actions: 'toggleSidebarMinimized' },
        HOVER_SIDEBAR: { actions: 'toggleSidebarHovered' },
        OPEN_HEADER: { actions: 'toggleHeaderOpened' },
      },
    },
  },
});

export { sidebarMachine };
